import { useEffect, useState } from "react";
import { InputBase, IconButton, MenuItem, TextField } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingShort from "../load/loadingShort";
import api from "../services/api";
import apiCNP from "../services/apiCNP";

const SearchEstabelecimento = ({
  setEstabelecimentos,
  setTipo = () => {},       // agora é opcional
  setProvincia = () => {},  // agora é opcional
  setStatus = () => {},     // já estava como opcional
  placeholder,
}) => {
  const [classeEstabelecimentos, setClasseEstabelecimentos] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [load, setLoad] = useState(false);
  const [search, setSearch] = useState("");
  const [status, setStatusState] = useState(""); // novo estado local para status

  const statusList = ["Activo", "Inactivo"];

  useEffect(() => {
    // Buscar categorias de estabelecimentos
    api
      .get("/tipo-estabelecimentos")
      .then((res) => {
        setClasseEstabelecimentos(res.data.tipoEstabelecimentos);
      })
      .catch((err) => console.error("Erro ao carregar categorias:", err));

    // Buscar Provincias para Filtro
    apiCNP
      .get("/Provincias")
      .then((res) => {
        setProvincias(res.data.provincias);
      })
      .catch((err) => console.error("Erro ao carregar categorias:", err));
  }, []);

  const searchEstabelecimento = async (e) => {
    e.preventDefault();
    setEstabelecimentos("");
    setLoad(true);

    try {
      const response = await api.post(`/estabelecimento/search`, {
        search,
        status: status, // usando o status local
      });

      setEstabelecimentos(response.data.estabelecimentos);
    } catch (error) {
      console.error(error);
      setEstabelecimentos("");
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    // Atualiza o status no componente pai
    setStatus(status); // Aqui estamos passando o status para o componente pai
  }, [status, setStatus]);

  return (
    <form
      onSubmit={searchEstabelecimento}
      style={{
        border: "1px solid #85287e",
        borderRadius: 5,
        display: "flex",
        gap: 10,
        padding: 5,
        flexWrap: "wrap",
        marginBottom: 25,
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        autoFocus
        placeholder={placeholder}
        inputProps={{ "aria-label": "Filtrar lista" }}
        onChange={(e) => setSearch(e.target.value)}
      />

      <IconButton type="submit" aria-label="search">
        {load ? <LoadingShort /> : <SearchOutlinedIcon />}
      </IconButton>

      {/* Filtro de Categoria */}
      <TextField
        style={{ width: 200 }}
        select
        size="small"
        variant="outlined"
        onChange={(e) =>
          setTipo(e.target.value === "Categorias" ? "" : e.target.value)
        }
        defaultValue="Categorias"
      >
        <MenuItem value="Categorias">Categorias</MenuItem>
        {classeEstabelecimentos?.map((classeEstabelecimento) => (
          <MenuItem
            key={classeEstabelecimento._id}
            value={classeEstabelecimento._id}
          >
            {classeEstabelecimento.designacao}
          </MenuItem>
        ))}
      </TextField>

      {/* Filtro de Provincias */}
      <TextField
        style={{ width: 200 }}
        select
        size="small"
        variant="outlined"
        onChange={(e) =>
          setProvincia(e.target.value === "Provincias" ? "" : e.target.value)
        }
        defaultValue="Provincias"
      >
        <MenuItem value="Provincias">Provincias</MenuItem>
        {provincias?.map((provincia) => (
          <MenuItem key={provincia._id} value={provincia.designacao}>
            {provincia.designacao}
          </MenuItem>
        ))}
      </TextField>

      {/* Filtro de Status (fixo) */}
      <TextField
        style={{ width: 150 }}
        select
        size="small"
        variant="outlined"
        onChange={(e) =>
          setStatusState(e.target.value === "Status" ? "" : e.target.value)
        } // altera o estado local
        defaultValue="Status"
      >
        <MenuItem value="Status">Status</MenuItem>
        {statusList.map((stat, idx) => (
          <MenuItem key={idx} value={stat}>
            {stat}
          </MenuItem>
        ))}
      </TextField>
    </form>
  );
};

export default SearchEstabelecimento;
